/**
 * Executes the ReCaptcha challenge for a given action.
 * Assumes the ReCaptcha script is already loaded.
 * @param action - The action for which to execute ReCaptcha.
 * @param siteKey - The site key for ReCaptcha.
 * @returns A promise that resolves to the ReCaptcha token.
 */
export const executeReCaptcha = (action: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject('ReCaptcha has not been loaded');
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha?.execute(process.env.GATSBY_RECAPTCHA_MKT_ID || '', { action }).then(
        (token) => resolve(token),
        (error) => reject(error),
      );
    });
  });
};
